// components/useRecordViewOnExpand.js
import { useRef } from 'react';
import { db } from '@root/firebase';
import {
  addDoc,
  collection,
  doc as fsDoc,
  updateDoc,
  serverTimestamp,
  increment,
} from 'firebase/firestore';

/**
 * Returns an onToggle handler that records a view once (on first expand).
 * If docPath or userId are missing, it does nothing.
 */
export function useRecordViewOnExpand({ docPath, userId, onViewed }) {
  const recordedRef = useRef(false);

  return async function handleToggle(isExpanded) {
    if (recordedRef.current) return;
    if (!isExpanded || !db || !docPath || !userId) return;

    try {
      const viewsCol = collection(db, `${docPath}/views`);
      await addDoc(viewsCol, { userId, createdAt: serverTimestamp() });

      const parentRef = fsDoc(db, docPath);
      await updateDoc(parentRef, { totalViews: increment(1) });

      recordedRef.current = true;
      onViewed?.();
    } catch (e) {
      // fail silently to keep UX smooth
      // console.warn('recordView failed', e);
    }
  };
}
